import React from "react";

import classNames from "classnames";
import styled from "styled-components";

import { useStores } from "../../../contexts/StoreContext";
import useDevice from "../../../shared/customHooks/useDevice";

const StyledAdditionalFooter = styled.div`
  color: #000;

  border-top: ${({ theme }) => `2px solid ${theme.primaryColor}`};
  a {
    color: ${({ theme }) => `${theme.primaryColor}`};
  }
`;

function MultiColumnAdditionalNavigation() {
  const { footerStore, navigationStore } = useStores();

  const { additionalFooterNavigation } = navigationStore;

  const { additionalFooterNavigationText } = footerStore;

  const { isMobile } = useDevice();

  const styledAdditionalFooterClassName = classNames("d-flex", {
    "flex-column align-items-center": isMobile,
    "justify-content-end": !isMobile,
  });

  return (
    <StyledAdditionalFooter className={styledAdditionalFooterClassName}>
      {isMobile && (
        <div className="text-center mb-4">
          <span className="d-block mb-4">{additionalFooterNavigationText}</span>
          {additionalFooterNavigation.map((navLink) => {
            return (
              <p key={navLink.title}>
                <a href={navLink.externalPath}>{navLink.title}</a>
              </p>
            );
          })}
        </div>
      )}
      {!isMobile && (
        <>
          {additionalFooterNavigation.map((navLink) => (
            <div key={navLink.title} className="px-5 py-3">
              <a className="me-1" href={navLink.externalPath}>
                {navLink.title}
              </a>
            </div>
          ))}
          {additionalFooterNavigationText && (
            <span className="px-5 py-3">{additionalFooterNavigationText}</span>
          )}
        </>
      )}
    </StyledAdditionalFooter>
  );
}

export default MultiColumnAdditionalNavigation;
